<script lang="ts">
  // This css import is necessary to avoid style flickering when navigating through routes.
  // This is only needed here.
  import '../app.css';

  import { onMount } from 'svelte';

  import ClientNotificationsBanner from '$lib/components/client-notifications-banner/ClientNotificationsBanner.svelte';
  import Toaster from '$lib/components/toaster/Toaster.svelte';
  import { watchApplicationChannel } from '$lib/services/application-channel';
  import { hasActiveNotifications, setNotifications } from '$lib/stores/client-notifications.store';
  import type { ClientNotification } from '$lib/stores/client-notifications.store';

  interface Props {
    children?: import('svelte').Snippet;
    data?: { notifications?: ClientNotification[] };
  }

  let { children, data }: Props = $props();

  $effect(() => setNotifications(data?.notifications ?? []));

  // Banner changes and release notices arrive over the app-wide Pusher
  // channel; onMount returns the cleanup that unbinds and unsubscribes.
  onMount(() => watchApplicationChannel());
</script>

{#if $hasActiveNotifications}
  <ClientNotificationsBanner />
{/if}

<Toaster />

{@render children?.()}
